import React, { useState, useContext, useEffect } from "react"

import { PCViewContext } from "./Common/PCViewContext"
import Footer from "./Common/Footer"
import Filter from "./Top/Filter"
import SectionContainer from "./Top/SectionContainer"
import Section from "./Top/Section"
import CrowdList from "./Top/CrowdList"
import TakeawayList from "./Top/TakeawayList"
import AreaList from "./Top/AreaList"
import AreaListPC from "./Top/AreaList/PC"
import PCContainer from "./Top/PCContainer"
import MainVisual from "./Top/MainVisual"
import Sentry from "./Common/Sentry"

import { GeolocationHandler } from "./Utils/geolocation_handler"
import { RequestHandler } from "./Utils/request_handler"
const geoHandler = new GeolocationHandler()
const FUZZY_SEARCH_PATH = "/search"

const execSearch = async (
  city,
  prefecture,
  category,
  setShowLoader,
  currentLocation
) => {
  setShowLoader(true)
  if (!city && !prefecture && !currentLocation) {
    await searchFromLocation(category)
    return setShowLoader(false)
  }

  const params = {}
  if (category) {
    params["category_id"] = category.id
  }
  if (currentLocation) {
    params["from"] = "current_location"
  }
  let path = ""
  if (city) {
    path = city.path
  } else if (prefecture) {
    path = prefecture.path
  } else if (category) {
    path = category.path
    delete params["category_id"]
  }

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&")
  document.location.href = query ? `${path}?${query}` : path
  setShowLoader(false)
}

const searchFromLocation = async (category) => {
  try {
    const coords: any = await geoHandler.getPosition()
    const params = {
      latitude: coords.latitude,
      longitude: coords.longitude,
    }
    if (category) {
      params["category_id"] = category.id
    }
    const handler = new RequestHandler(FUZZY_SEARCH_PATH, "POST", params)
    const res = await handler.requestWithBody()
    if (res.status != 200) {
      Sentry.captureMessage(res.body)
      alert("通信に失敗しました。時間を置いてもう一度お試しください。")
    }
    if (res.body.location) {
      document.location = res.body.location
    }
  } catch (e) {
    Sentry.captureException(e)
    alert(
      "現在地の取得に失敗しました。エリアを選択してもう一度お試しください。"
    )
  }
}

const fetchCrowdList = async () => {
  try {
    const handler = new RequestHandler("/places?lamp_updated_only=1", "GET")
    const res = await handler.requestWithBody()
    if (res.status == 200) {
      return res.body
    }
    return []
  } catch (e) {
    Sentry.captureException(e)
    return []
  }
}

const Top = (props) => {
  const handleSubmit = async (city, prefecture, category) => {
    await execSearch(city, prefecture, category, setShowLoader, currentLocation)
  }
  const [showLoader, setShowLoader] = useState(false)
  const [componentDisabled, setComponentDisabled] = useState(false)
  const [currentLocation, setCurrentLocation] = useState(null)
  const [crowdList, setCrowdList] = useState([])
  const [showCrowdLoader, setShowCrowdLoader] = useState(true)
  const isPC = useContext(PCViewContext)

  useEffect(() => {
    if (currentLocation == "Loading") {
      setComponentDisabled(true)
    } else {
      setComponentDisabled(false)
    }
  }, [currentLocation])

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        const list = await fetchCrowdList()
        setCrowdList(list)
        setShowCrowdLoader(false)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [])

  const states = {
    setCurrentLocation,
    showLoader,
    componentDisabled,
    onSubmit: handleSubmit,
  }

  return (
    <React.Fragment>
      {isPC && (
        <React.Fragment>
          <PCContainer>
            <MainVisual {...props} {...states} />
            <SectionContainer>
              {(crowdList.length > 0 || showCrowdLoader) && (
                <Section>
                  <CrowdList
                    {...props}
                    places={crowdList}
                    showLoader={showCrowdLoader}
                  />
                </Section>
              )}
              <Section withBottomPadding={true}>
                <TakeawayList
                  {...props}
                  onClick={() => {
                    handleSubmit(null, null, props.takeawayCategory)
                  }}
                  {...states}
                />
              </Section>
              <Section withBottomPadding={true}>
                <AreaListPC {...props} />
              </Section>
            </SectionContainer>
          </PCContainer>
          <Footer {...props} isPC={isPC} />
        </React.Fragment>
      )}
      {!isPC && (
        <React.Fragment>
          <Filter {...props} {...states} />
          <SectionContainer>
            {(crowdList.length > 0 || showCrowdLoader) && (
              <Section>
                <CrowdList
                  {...props}
                  places={crowdList}
                  showLoader={showCrowdLoader}
                />
              </Section>
            )}
            <Section withBottomPadding={true}>
              <TakeawayList
                {...props}
                onClick={() => {
                  handleSubmit(null, null, props.takeawayCategory)
                }}
                {...states}
              />
            </Section>
            <Section>
              <AreaList
                {...props}
                onClick={(pref) => {
                  if (pref.path) {
                    document.location = pref.path
                  }
                }}
              />
            </Section>
          </SectionContainer>
          <Footer />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
export default Top
